import { adaptShoppingContext } from 'stores/adapters/bex-api/migration-adapters/property-info/shopping-context-response-adapter';

import { HotelRoomsAndRatesViewModel } from 'models';

import { adaptErrorMessage, adaptErrorMessageModel } from './error-message-adapter';
import { adaptFlyInModel } from './property-toast-message-adapter';
import { adaptLegalBannerMessagingCard, adaptMessagingCard } from './property-offers-message-adapter';
import { adaptStickyOffer } from './property-stickyBar-adapter';
import { OperationResult, PropertyInfoOffersBexFeatures } from 'src/common/__generated__/api';

export const adaptPropertyInfoOffers = (response: OperationResult<PropertyInfoOffersBexFeatures.Query>): HotelRoomsAndRatesViewModel => {
  if (!response) {
    return null;
  }

  const loyaltyDiscount = getPropertyLoyaltyDiscount(response);
  const legalDisclaimer = getPropertyLoyaltyDisclaimer(response);
  const errorMessage = response?.data?.propertyInfo?.offers?.errorMessage;
  const serpMetadata = getSerpMetaData(response);
  const propertySearchLink = getPropertySearchLink(response);
  const filterPills = getFilterPills(response);
  const listingsHeader = getListingsHeader(response);
  const alternateDatesCard = getAlternativeDates(response);
  const partnerPropertySearchLink = getPartnerPropertySearchLink(response);
  const shoppingContext = getShoppingContext(response);
  const spaceDetails = response?.data?.propertyInfo?.offers?.spaceDetails;
  const singleUnitOffer = response?.data?.propertyInfo?.offers?.singleUnitOffer;
  const singleUnitOfferDialog = response?.data?.propertyInfo?.offers?.singleUnitOfferDialog;
  const propertyLevelOffersMessage = response?.data?.propertyInfo?.offers?.propertyLevelOffersMessage;

  return {
    legalBanner: adaptLegalBannerMessagingCard(response),
    errorMessage: adaptErrorMessage(errorMessage),
    errorMessagingModel: adaptErrorMessageModel(errorMessage),
    flyInModel: adaptFlyInModel(response),
    messagingCardModel: adaptMessagingCard(response),
    stickyOffer: adaptStickyOffer(response),
    propertyHighlightSection: getPropertyHighlightSection(response),
    shoppingContext,
    alternateDatesCard,
    filterPills,
    listingsHeader,
    propertySearchLink,
    serpMetadata,
    loyaltyDiscount,
    legalDisclaimer,
    partnerPropertySearchLink,
    spacesViewModel: spaceDetails,
    singleUnitOffer,
    singleUnitOfferDialog,
    propertyLevelOffersMessage,
  } as HotelRoomsAndRatesViewModel;
};

const getAlternativeDates = response => response?.data?.propertyInfo?.offers?.alternateDates;
const getFilterPills = response => response?.data?.propertyInfo?.offers?.filterPills;
const getListingsHeader = response => response?.data?.propertyInfo?.offers?.listingsHeader;
const getPropertySearchLink = response => response?.data?.propertyInfo?.offers?.propertySearchLink;
const getSerpMetaData = response => response?.data?.propertyInfo?.offers?.serpMetadata;
const getPropertyLoyaltyDiscount = response => response?.data?.propertyInfo?.offers?.loyaltyDiscount;
const getPropertyLoyaltyDisclaimer = response => response?.data?.propertyInfo?.offers?.legalDisclaimer;
const getPartnerPropertySearchLink = response => response?.data?.propertyInfo?.offers?.partnerPropertySearchLink;
const getPropertyHighlightSection = response => response?.data?.propertyInfo?.offers?.propertyHighlightSection;
const getShoppingContext = response => adaptShoppingContext(response?.data?.propertyInfo?.offers?.shoppingContext?.multiItem);
